import { Card, Grid, Stack, Typography, useMediaQuery } from '@mui/material'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import WarningIcon from '@mui/icons-material/ReportOutlined';
import ReturnIcon from '@mui/icons-material/AssignmentReturnOutlined';
import BookIcon from '@mui/icons-material/CollectionsBookmarkOutlined';
import { Box } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { getNumber, getPenaltyNumber, getRequestNumber, getReturnNumber, resetTransactions } from '../redux/actions/transactionAction';
export default function Dashboard() {
    const matches = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const transaction = useSelector((state => state.transaction))
    const style = {
        cardDashboard: {
            borderRadius: 4,
            boxShadow: 3,
            border: "3px solid white",
            minHeight: 90,
            opacity: 0.9,
            "&:hover": {
                cursor: "pointer",
                boxShadow: 1
            },

        }
    }
    const history = useHistory();
    const dispatch = useDispatch(); 
    const cardLink = (linkString) => (e) => {
        e.preventDefault();
        dispatch(resetTransactions())
        history.push(linkString)
    }
    useEffect(() => {
        if (transaction.dashboardNumbers.length <= 4) {
            if (!transaction.numberEmpty && transaction.number === 0) dispatch(getNumber());
            if (!transaction.lateNumberEmpty && transaction.lateNumber === 0) dispatch(getPenaltyNumber());
            if (!transaction.returnNumberEmpty && transaction.returnNumber === 0) dispatch(getReturnNumber());
            if (!transaction.requestNumberEmpty && transaction.requestNumber === 0) dispatch(getRequestNumber());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Grid container columns={12} spacing={3} sx={{ marginBottom: 2 }}>
            <Grid item xs={6} md={3}>
                <Card
                    onClick={cardLink("/mybooks/requests")}
                    variant="outlined"
                    sx={{ ...style.cardDashboard, backgroundColor: "#A2BAD6" }}>
                    <Stack direction="row" alignItems="center" >
                        <WarningIcon sx={{ fontSize: matches ? 50 : 80 , color: "white", marginLeft: 1 }} />
                        <Box component="span" sx={{ flexGrow: 1 }} />
                        <Stack direction="column" alignItems="flex-end" sx={{ marginRight: 2, color: "white" }}>
                            <Typography variant="h3" sx={{ marginBottom: 0 }}>{transaction.requestNumber}</Typography>
                            <Typography variant="h6" >Requests</Typography>
                        </Stack>
                    </Stack>
                </Card>
            </Grid>
            <Grid item xs={6} md={3}>
                <Card
                    onClick={cardLink("/mybooks/reserve")}
                    variant="outlined"
                    sx={{ ...style.cardDashboard, backgroundColor: "#FFCC64" }}>
                    <Stack direction="row" alignItems="center" >
                        <BookIcon sx={{ fontSize: matches ? 50 : 80, color: "white", marginLeft: 1 }} />
                        <Box component="span" sx={{ flexGrow: 1 }} />
                        <Stack direction="column" alignItems="flex-end" sx={{ marginRight: 2, color: "white" }}>
                            <Typography variant="h3" sx={{ marginBottom: 0 }}>{transaction.number}</Typography>
                            <Typography variant="h6" >Reserved</Typography>
                        </Stack>
                    </Stack>
                </Card>
            </Grid>
            <Grid item xs={6} md={3}>
                <Card
                    onClick={cardLink("/mybooks/return")}
                    variant="outlined"
                    sx={{ ...style.cardDashboard, backgroundColor: "#95D42D" }}>
                    <Stack direction="row" alignItems="center" >
                        <ReturnIcon sx={{ fontSize: matches ? 50 : 80, color: "white", marginLeft: 1 }} />
                        <Box component="span" sx={{ flexGrow: 1 }} />
                        <Stack direction="column" alignItems="flex-end" sx={{ marginRight: 2, color: "white" }}>
                            <Typography variant="h3" sx={{ marginBottom: 0 }}>{transaction.returnNumber}</Typography>
                            <Typography variant="h6" >Returned</Typography>
                        </Stack>
                    </Stack>
                </Card>
            </Grid>
            <Grid item xs={6} md={3}>
                <Card
                    onClick={cardLink("/mybooks/penalty")}
                    variant="outlined"
                    sx={{ ...style.cardDashboard, backgroundColor: "#FF6249" }}>
                    <Stack direction="row" alignItems="center" >
                        <WarningIcon sx={{ fontSize: matches ? 50 : 80, color: "white", marginLeft: 1 }} />
                        <Box component="span" sx={{ flexGrow: 1 }} />
                        <Stack direction="column" alignItems="flex-end" sx={{ marginRight: 2, color: "white" }}>
                            <Typography variant="h3" sx={{ marginBottom: 0 }}>{transaction.lateNumber}</Typography>
                            <Typography variant="h6" >Penalty</Typography>
                        </Stack>
                    </Stack>
                </Card>
            </Grid>
            
        </Grid >
    )
}
